import { render, staticRenderFns } from "./ManagingRolesAndPermissions.vue?vue&type=template&id=046289d1"
import script from "./ManagingRolesAndPermissions.vue?vue&type=script&lang=js"
export * from "./ManagingRolesAndPermissions.vue?vue&type=script&lang=js"
import style0 from "./ManagingRolesAndPermissions.vue?vue&type=style&index=0&id=046289d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports